import { AlgoIndexTypes } from '~/builder/utils/getAlgoConfig';

const FableticsQuickViewCollectionBuilderComponent = {
  name: '_QuickViewCollection_',
  inputs: [
    {
      name: 'fplGlobalCodes',
      type: 'list',
      localized: false,
      subFields: [
        {
          name: 'fplGlobalCode',
          type: 'string',
          localized: false,
          helperText:
            'If no FPLs are provided, the grid will be powered via an algorithm.',
        },
      ],
    },
    {
      name: 'excludeFpls',
      type: 'list',
      localized: false,
      subFields: [
        {
          name: 'excludeFpl',
          type: 'number',
          localized: false,
          required: false,
        },
      ],
    },
    {
      name: 'excludeTagIds',
      type: 'list',
      localized: false,
      subFields: [
        {
          name: 'excludeTagId',
          type: 'number',
          localized: false,
          required: false,
        },
      ],
    },
    {
      name: 'productSource',
      friendlyName: 'P-Source',
      helperText:
        'This field sets the P-Source name to track revenue for the page',
      type: 'string',
    },
    {
      name: 'algoOptions',
      type: 'object',
      localized: false,
      advanced: true,
      subFields: [
        {
          name: 'esIndex',
          friendlyName: 'ES Index',
          type: 'string',
          enum: ['', ...Object.values(AlgoIndexTypes)],
        },
        {
          name: 'algorithmPageSize',
          type: 'number',
          defaultValue: null,
          localized: false,
          required: false,
        },
        {
          name: 'fallbackFpl',
          friendlyName: 'Fallback FPL',
          helperText:
            'Sets the fallback FPL when the algo threshold is not met. Supports either FPL code or ID',
          type: 'string',
          required: false,
        },
        {
          name: 'fallbackFplThreshold',
          friendlyName: 'FPL fallback threshold',
          type: 'number',
          defaultValue: 0,
          localized: false,
          required: false,
        },
        {
          name: 'disableCollectionOnThresholdUnmet',
          friendlyName: 'Disable Collection When Threshold Unmet?',
          helperText:
            'Disables the collection entirely when the algo threshold is not met and no Fallback FPL is specified.',
          type: 'boolean',
          defaultValue: false,
          required: false,
        },
        {
          name: 'debug',
          friendlyName: 'Algorithm Debug (FOR DEVELOPERS ONLY)',
          type: 'boolean',
          defaultValue: false,
          hideFromUI: true,
        },
      ],
    },
  ],
} as const;

export default FableticsQuickViewCollectionBuilderComponent;
